import { bizMinVersionConfigs } from '@/constant';
import { getAppVersionString, getPlatform } from './misc';
import Modal from '@/components/Modal';

export const COMPARE_RESULT = {
  EQ: 0,
  GT: 1,
  LT: -1,
};
// return 1 if target>base
// return -1 if target<base
// return 0 if target==base
export const compare = (target: string, base: string) => {
  if (typeof target !== 'string' || typeof base !== 'string') return 1; // for pc log error

  const targetParts = target.split('.');
  const baseParts = base.split('.');
  const length = Math.max(targetParts.length, baseParts.length);
  for (let i = 0; i < length; i++) {
    const curTarget = parseInt(targetParts[i] || '0');
    const curBase = parseInt(baseParts[i] || '0');
    if (curBase === curTarget) continue;
    return curTarget > curBase ? 1 : -1;
  }
  return 0;
};

export const lt = (target: string, base: string) => {
  return [COMPARE_RESULT.LT].includes(compare(target, base));
};

// handle back compability
export const needHandleBackCompability = (url, event) => {
  // for example: kill switch back compability, < v1.6.3 show modal by h5
  if (isLowVersionAndShowModal(url)) {
    event.preventDefault();
    Modal.show();
    return true;
  }
  return false;
};

export const isLowVersionAndShowModal = (url: string) => {
  const currentVersion = getAppVersionString();

  return Object.entries(bizMinVersionConfigs).some(
    (item) => url.includes(item[0]) && compare(currentVersion, item[1]) === -1,
  );
};

export const checkCanOpenPDFVersion = () => {
  const CHECK_VERSION = '1.11.0';
  const currentVersion = getAppVersionString();
  const platform = getPlatform();
  if (platform !== 'ios') {
    if (compare(currentVersion, CHECK_VERSION) === -1) {
      Modal.show();
      return false;
    }
    return true;
  }
  return true;
};
